import { useEffect, useMemo } from 'react';
import type { ProjectType } from '@trinity/chat';
import { type BrandInsightsPageContext } from '@trinity/chat';
import { useRegisterChatPageContext } from '@trinity/chat-components/components/Chat/hooks/useRegisterPageContext.js';
import { ChatContextType } from '@/enums/chat';

export const useRegisterProjectChat = (data: {
  enabled: boolean;
  project: {
    id: number;
    name: string;
    projectType: ProjectType;
  } | null;
}) => {
  const chatContext: BrandInsightsPageContext.Project = useMemo(() => {
    if (!data.enabled || !data.project) return null;

    return {
      type: ChatContextType.Project,
      data: {
        projectId: data.project.id,
      },
      metadata: {
        name: data.project.name,
        projectType: data.project.projectType,
        // hasQuantAnalysisFiles: data.project.hasQuantAnalysisFiles,
        supportsUploads: false,
      },
    };
  }, [data]);

  const register = useRegisterChatPageContext();

  useEffect(() => {
    if (!chatContext) return;

    register(chatContext);
  }, [register, chatContext]);
};